import { GoogleMapControlPosition } from '~/constants/google/map'

export function useGoogleMapControl() {
  function addControlToMap(
    control: any,
    map: google.maps.Map,
    position: GoogleMapControlPosition
  ): void {
    if (!map) {
      return
    }
    map.controls[position].push(control)
  }

  function createControl(text: string) {
    function createButton(title: string = ''): HTMLElement {
      const buttonEl = document.createElement('div')
      buttonEl.style.backgroundColor = '#fff'
      buttonEl.style.border = '2px solid #fff'
      buttonEl.style.borderRadius = '3px'
      buttonEl.style.boxShadow = 'rgb(0 0 0 / 30%) 0px 1px 4px -1px'
      buttonEl.style.cursor = 'pointer'
      buttonEl.style.margin = '8px'
      buttonEl.style.textAlign = 'center'
      buttonEl.title = title
      return buttonEl
    }

    function createText(text: string = '') {
      const textEl = document.createElement('div')

      textEl.style.color = 'rgb(25,25,25)'
      textEl.style.fontSize = '14px'
      textEl.style.lineHeight = '24px'
      textEl.style.paddingLeft = '5px'
      textEl.style.paddingRight = '5px'
      textEl.innerHTML = text
      return textEl
    }
    const buttonEl = createButton(text)
    const textEl = createText(text)
    buttonEl.appendChild(textEl)
    return buttonEl
  }

  return { createControl, addControlToMap }
}
